import { TradeMethodAutomationSourcesPage } from 'features/trade-methods';

export const TechOperatorTradeMethodAutomationSourcesPage = () => (
  <TradeMethodAutomationSourcesPage />
);
